import chroma from 'chroma-js';

export function selectHighestContrast(baseColor: string, colorList: string[]): string {
  let highestContrastColor = colorList[0];
  let highestContrastValue = chroma.contrast(baseColor, highestContrastColor);

  colorList.forEach((color, index) => {
    // Skip the first color as that is the benchmark
    if (index === 0) {
      return;
    }

    const currContrastValue = chroma.contrast(baseColor, color);
    if (currContrastValue > highestContrastValue) {
      highestContrastColor = color;
      highestContrastValue = currContrastValue;
    }
  });

  return highestContrastColor;
}
